import { render, staticRenderFns } from "./NetgsmChannelDetail.vue?vue&type=template&id=04738c48&scoped=true"
import script from "./NetgsmChannelDetail.vue?vue&type=script&lang=js"
export * from "./NetgsmChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./NetgsmChannelDetail.vue?vue&type=style&index=0&id=04738c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04738c48",
  null
  
)

export default component.exports